export { default as ProductsIndexPageCategoriesNavHead } from './ProductsIndexPageCategoriesNavHead';
